module.exports = __webpack_public_path__ + "img/benefit_03.de4b54c4.svg";